import { render, staticRenderFns } from "./Cidade.FormView.vue?vue&type=template&id=73956df6"
import script from "./Cidade.FormView.vue?vue&type=script&lang=js"
export * from "./Cidade.FormView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports